import React from "react";
import { fetchSettings, updateSettings} from "../../../util/settings_api_util"

export default class AdminSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newOrderProcess: false,
      bundleDiscountWith2: 0,
      bundleDiscountWith3: 0,
      bundleDiscountWith4: 0
    }
    this.handleToggle = this.handleToggle.bind(this);
    this.handleNumberInput = this.handleNumberInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    fetchSettings().then(data => {
      this.setState({
        newOrderProcess: data.new_order_process,
        bundleDiscountWith2: data.bundle_discount_with_2,
        bundleDiscountWith3: data.bundle_discount_with_3,
        bundleDiscountWith4: data.bundle_discount_with_4
      });
    });
  }

  handleToggle() {
    this.setState(prevState => ({ newOrderProcess: !prevState.newOrderProcess }))
  }

  handleNumberInput(field) {
    return (e) => {
      const value = parseFloat(e.target.value);
      this.setState({ [field]: isNaN(value) ? null : value });
    }

  }

  handleSubmit = () => {
    const { newOrderProcess, bundleDiscountWith2, bundleDiscountWith3, bundleDiscountWith4 } = this.state;

    const requestBody = {
      new_order_process: newOrderProcess,
      bundle_discount_with_2: bundleDiscountWith2,
      bundle_discount_with_3: bundleDiscountWith3,
      bundle_discount_with_4: bundleDiscountWith4
    };

    updateSettings(requestBody)
      .then(() => this.props.showToast("Settings updated successfully"))
      .catch(() => this.props.showToast("Error updating settings."));
  }

  render() {
    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences">
          <div className="settingsComponentHeading">Admin Settings</div>
          <div className="settingsGroup">
            <div className="settingsCompanyInput">
              <span className="formLabel">New Order Process</span>
              <div
                className={`toggle-switch ${this.state.newOrderProcess ? 'active' : ''}`}
                onClick={() => this.setState({ newOrderProcess: !this.state.newOrderProcess })}
              >
                <div className="toggle-knob"></div>
              </div>
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 2 Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith2} onChange={this.handleNumberInput("bundleDiscountWith2")} />
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 3 Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith3} onChange={this.handleNumberInput("bundleDiscountWith3")} />
            </div>

            <div className="settingsCompanyInput">
              <label id="formLabel">Bundle Discount for 4+ Services (%)</label>
              <input className="formInput" type="number" step="any" value={this.state.bundleDiscountWith4} onChange={this.handleNumberInput("bundleDiscountWith4")} />
            </div>

            <button className="settingsButton companyButton" onClick={() => this.handleSubmit()}>Update Settings</button>
          </div>
        </div>
      </div>
    );}
}
